export const SET_COLS = 'SET_COLS';

export const SET_TAB_SIZE = 'SET_TAB_SIZE';

export const SET_TEXT_CONTENT = 'SET_TEXT_CONTENT';

export const SET_FONT_SIZE = 'SET_FONT_SIZE';



// WEBPACK FOOTER //
// ./src/reducers/types.js